<main>
  <div class="container region col-sm-12 col-md-12 col-lg-10 col-xl-8">
    @if (winRef.isBrowser()) {
      @if (currentBaseSite$ | async; as baseSite) {
        @if (baseSite.country?.name) {
          <div class="region-suggestion">
            <h1>
              {{
                'languageSelectorPage.suggestionHeader'
                  | transloco: { baseSiteName: baseSite.country?.name }
              }}
            </h1>
            <div class="region-suggestion-text">
              <span>{{
                'languageSelectorPage.suggestionText' | transloco
              }}</span>
            </div>
            <div class="region-suggestion-bottom">
              @for (
                language of baseSite?.stores?.[0]?.languages;
                track language
              ) {
                <button
                  (click)="
                    setBaseSiteLanguage({
                      baseSite: baseSite,
                      language: language,
                    })
                  "
                  class="btn btn-secondary"
                >
                  {{ language.nativeName }}
                </button>
              }
            </div>
          </div>
        }
      } @else {
        @if ((currentBaseSite$ | async) !== undefined) {
          <div class="loadingSuggestion">
            <boels-spinner></boels-spinner>
          </div>
        }
      }
    }
    @if (baseSites$ | async; as baseSites) {
      <div class="region-selection">
        @if (winRef.isBrowser()) {
          <div class="region-selection-header">
            @if (currentBaseSite$ | async; as baseSite) {
              @if (baseSite.country?.name) {
                <h4>
                  {{
                    'languageSelectorPage.selectionHeaderWithCurrentBaseSite'
                      | transloco
                  }}
                </h4>
              } @else {
                <h1>
                  {{ 'languageSelectorPage.selectionHeader' | transloco }}
                </h1>
              }
            } @else {
              <h1>{{ 'languageSelectorPage.selectionHeader' | transloco }}</h1>
            }
          </div>
        }
        <div class="region-selection-grid">
          @for (baseSite of baseSites; track trackByUid($index, baseSite)) {
            <boels-language-selector-page-item
              (baseSiteLanguageEventEmitter)="setBaseSiteLanguage($event)"
              [baseSite]="baseSite"
              [urlAfterRedirects]="urlAfterRedirects"
            ></boels-language-selector-page-item>
          }
        </div>
      </div>
    } @else {
      <div class="loadingBaseSites">
        <boels-spinner></boels-spinner>
      </div>
    }
  </div>
</main>

<ng-template #loadingSuggestion>
  @if ((currentBaseSite$ | async) !== undefined) {
    <div class="loadingSuggestion">
      <boels-spinner></boels-spinner>
    </div>
  }
</ng-template>

<ng-template #loadingBaseSites>
  <div class="loadingBaseSites">
    <boels-spinner></boels-spinner>
  </div>
</ng-template>
